export function clampPercent(value?: number | null): number {
  if (value == null || Number.isNaN(Number(value))) {
    return 0;
  }

  return Math.min(100, Math.max(0, Math.round(Number(value))));
}
